import callVendorRoutes from './call-vendor/routes.js'
import newExpenseRoutes from './new-expense/routes.js'
import newRequisitionroutes from './new-requisition/routes.js'
import orderRoutes from './order/routes.js'
import requestQuotesRoutes from './request-quotes/routes.js'

const routes = [
  {
    path: '/',
    component: () => import('layouts/main-layout.vue'),
    meta: { protected: true },
    children: [
      {
        path: '',
        name: 'index',
        meta: { navTab: 'home', showFooter: true, showFreshdeskIcon: true },
        component: () => import('pages/index.vue')
      },
      {
        path: 'boms',
        name: 'boms',
        meta: { hideBackButton: true, hideCloseButton: true, navTab: 'boms', showFooter: true },
        component: () => import('pages/boms/index.vue')
      },
      {
        path: 'boms/:id',
        component: () => import('pages/boms/_id.vue'),
        children: [
          {
            path: '',
            component: () => import('pages/boms/_id/index.vue'),
            children: [
              {
                path: '',
                name: 'boms-id',
                component: () => import('pages/boms/_id/items/index.vue'),
              },
              {
                path: 'items/:uuid',
                name: 'boms-id-items-uuid',
                component: () => import('pages/bom-items/_uuid.vue'),
              },
              {
                path: 'items/:item/orders',
                name: 'boms-id-items-item-orders',
                component: () => import('pages/boms/_id/items/_item.vue/orders.vue'),
                meta: { hideBackButton: true },
              },
            ],
          },
        ],
      },
      {
        path: 'boms/new',
        name: 'boms-new',
        component: () => import('pages/boms/new.vue')
      },
      {
        path: 'call-vendor',
        component: () => import('pages/call-vendor.vue'),
        children: callVendorRoutes
      },
      {
        path: 'confirm-phone-order/:id',
        name: 'confirm-phone-order',
        component: () => import('pages/orders/confirm-phone-order.vue')
      },
      {
        path: 'create-po',
        component: () => import('pages/create-po.vue'),
        meta: { hideCloseButton: true },
        children: [
          {
            name: 'create-po',
            path: '',
            component: () => import('pages/create-po/index.vue')
          },
          {
            path: 'bom-items',
            component: () => import('pages/bom-items.vue'),
            children: [
              {
                name: 'create-po-bom-items',
                path: '',
                component: () => import('pages/bom-items/index.vue'),
                meta: { hideBackButton: true },
              },
              {
                name: 'create-po-bom-items-uuid',
                path: ':uuid',
                component: () => import('pages/bom-items/_uuid.vue'),
              },
            ]
          },
        ],
      },
      {
        path: 'error-test',
        name: 'error-test',
        component: () => import('pages/error-test.vue')
      },
      {
        path: 'expenses',
        children: [
          {
            path: '',
            name: 'expenses',
            meta: {
              hideBackButton: true,
              hideCloseButton: true,
              navTab: 'expenses',
              showFooter: true,
            },
            component: () => import('pages/expenses/index.vue'),
          },
          {
            path: ':id',
            component: () => import('pages/expenses/_id.vue'),
            children: [
              {
                path: '',
                name: 'expenses-id',
                component: () => import('pages/expenses/_id/index.vue'),
              },
              {
                path: 'edit',
                name: 'expenses-id-edit-index',
                meta: { hideCloseButton: true },
                component: () => import('pages/expenses/_id/edit/index.vue')
              },
              {
                path: 'edit/items',
                name: 'expenses-id-edit-items',
                component: () => import('pages/expenses/_id/edit/items.vue'),
              },
            ],
          },
          {
            path: 'new',
            component: () => import('pages/expenses/new.vue'),
            children: newExpenseRoutes
          },
        ]
      },
      {
        path: 'in-store-po',
        name: 'in-store-po',
        meta: { hideBackButton: true },
        component: () => import('pages/in-store-po/index.vue')
      },
      {
        path: 'in-store-po/:id/attach-receipt',
        name: 'in-store-po-id-attach-receipt',
        component: () => import('pages/in-store-po/_id/attach-receipt.vue')
      },
      {
        path: 'inventory',
        component: () => import('pages/inventory.vue'),
        children: [
          {
            path: '',
            name: 'inventory',
            meta: { navTab: 'inventory' },
            component: () => import('pages/inventory/index.vue'),
          },
          {
            path: ':id',
            name: 'inventory-id',
            component: () => import('pages/inventory/_id.vue'),
            meta: {
              hideCloseButton: true,
            },
          },
          {
            path: 'transfer',
            component: () => import('pages/inventory/transfer.vue'),
            children: [
              {
                path: '',
                name: 'inventory-transfer',
                component: () => import('pages/inventory/transfer/index.vue'),
              },
              {
                path: ':item',
                name: 'inventory-transfer-item',
                component: () => import('pages/inventory/transfer/_item.vue'),
              },
              {
                path: 'review',
                name: 'inventory-transfer-review',
                component: () => import('pages/inventory/transfer/review.vue'),
              },
            ],
          }
        ],
      },
      {
        path: 'notifications',
        name: 'notifications',
        meta: { navTab: 'home', showFooter: true, hideCloseButton: true },
        component: () => import('pages/notifications.vue')
      },
      {
        path: 'more',
        name: 'more',
        meta: {
          hideBackButton: true,
          hideCloseButton: true,
          navTab: 'more',
          showFooter: true,
          showFreshdeskIcon: true
        },
        component: () => import('pages/more.vue')
      },
      {
        path: 'orders',
        children: [
          {
            path: '',
            component: () => import('pages/orders.vue'),
            meta: {
              hideBackButton: true,
              hideCloseButton: true,
              navTab: 'orders',
              showFooter: true,
            },
            children: [
              {
                path: '',
                name: 'orders',
                component: () => import('pages/orders/index.vue'),
              },
              {
                path: 'todo',
                name: 'orders-todo',
                component: () => import('pages/orders/todo.vue')
              },
              {
                path: 'mine',
                name: 'orders-mine',
                component: () => import('pages/orders/mine.vue')
              },
            ],
          },
          {
            path: ':id',
            component: () => import('pages/orders/_id.vue'),
            children: orderRoutes
          },
        ],
      },
      {
        path: 'requisitions',
        children: [
          {
            path: '',
            name: 'requisitions',
            meta: {
              hideBackButton: true,
              hideCloseButton: true,
              navTab: 'requisitions',
              showFooter: true,
            },
            component: () => import('pages/requisitions/index.vue'),
          },
          {
            path:'mine',
            name: 'requisitions-mine',
            meta: {
              hideBackButton: true,
              hideCloseButton: true,
              navTab: 'requisitions',
              showFooter: true,
            },
            component: () => import('pages/requisitions/index.vue'),
          },
          {
            path: ':id',
            name: 'requisitions-id',
            component: () => import('pages/requisitions/_id/index.vue')
          },
          {
            path: ':id/edit/index',
            name: 'requisitions-id-edit-index',
            meta: {
              hideCloseButton: true,
            },
            component: () => import('pages/requisitions/_id/edit/index.vue')
          },
          {
            path: ':id/edit/delivery',
            name: 'requisitions-id-edit-delivery',
            meta: {
              hideCloseButton: true,
            },
            component: () => import('pages/requisitions/_id/edit/delivery.vue')
          },
          {
            path: ':id/edit/approval',
            name: 'requisitions-id-edit-approval',
            meta: {
              hideCloseButton: true,
            },
            component: () => import('pages/requisitions/_id/edit/approval.vue')
          },
          {
            path: 'new',
            component: () => import('pages/requisitions/new.vue'),
            children: newRequisitionroutes,
          },
        ],
      },
      {
        path: 'request-quotes',
        component: () => import('pages/request-quotes.vue'),
        children: requestQuotesRoutes,
      },
      {
        path: 'success',
        name: 'success',
        meta: { hideHeader: true },
        component: () => import('pages/success.vue')
      },
      {
        path: 'settings',
        name: 'settings',
        meta: {
          hideBackButton: true,
          hideCloseButton: true,
          navTab: 'profile',
          showFooter: true,
        },
        component: () => import('pages/settings/index.vue')
      },
      {
        path: 'settings/notifications',
        name: 'settings-notifications',
        component: () => import('pages/settings/notifications.vue')
      },
      // Added to have the same url than web FE
      {
        path: 'profile/notifications',
        name: 'profile-notifications',
        component: () => import('pages/settings/notifications.vue')
      },
      {
        path: 'settings/account',
        name: 'settings-account',
        component: () => import('pages/settings/account.vue')
      },
      {
        path: 'settings/change-password',
        name: 'settings-change-password',
        component: () => import('pages/settings/change-password.vue')
      },
      {
        path: 'settings/projects',
        name: 'settings-projects',
        component: () => import('pages/settings/projects.vue')
      },
      {
        path: 'setup-mode',
        name: 'setup-mode',
        meta: {
          hideBackButton: true,
          hideCloseButton: true,
          showFooter: false,
          hideHeader: true
        },
        component: () => import('pages/setup-mode.vue')
      },
      {
        path: 'settings/change-environment',
        name: 'settings-change-environment',
        component: () => import('pages/settings/change-environment.vue')
      },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/logged-out-layout.vue'),
    meta: { clearToken: true },
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import('pages/login.vue')
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: () => import('pages/forgot-password/index.vue')
      },
      {
        path: 'forgot-password/check-email',
        name: 'forgot-password-check-email',
        component: () => import('pages/forgot-password/check-email.vue')
      },
      {
        path: 'forgot-password/success',
        name: 'forgot-password-success',
        component: () => import('pages/forgot-password/success.vue')
      },
      {
        path: 'forgot-password/:uuid/reset',
        name: 'forgot-password-reset',
        component: () => import('pages/forgot-password/_uuid/reset.vue')
      },
      {
        path: 'users/accept-invite/success',
        name: 'users-accept-invite-success',
        component: () => import('pages/users/accept-invite/success.vue')
      },
      {
        path: 'users/accept-invite/:uuid',
        name: 'users-accept-invite',
        component: () => import('pages/users/accept-invite/_uuid/index.vue')
      }
    ]
  }
]

// Always leave this as last one
// If the route does not match any other route, go to the home page
routes.push({
  path: '/:catchAll(.*)*',
  component: () => import('layouts/main-layout.vue'),
  meta: { protected: true },
  children: [
    {
      path: '',
      name: 'index-fallback',
      component: () => import('pages/index.vue'),
      meta: { navTab: 'home', showFooter: true, showFreshdeskIcon: true },
    },
  ]
})

export default routes
